module.exports = __webpack_public_path__ + "img/shiba-body-level2.5eba659d.png";